import {
  Dialog,
  DialogContent,
  DialogBody,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@repo/ui/components/Base/Dialog";
import { useNestedComponent } from "@repo/ui/components/Base/hooks/useNestedComponent";
import { PlusCircleIcon } from "lucide-react";

export interface FormDialogFormProps {
  handleCancel?: () => void;
  handleComplete?: () => void;
}

interface FormDialogProps {
  open: boolean;
  setOpen: (arg: boolean) => void;
  title: string;
  triggerLabel?: string;
  showTrigger?: boolean;
  closeOnOverlay?: boolean;
  form: React.FC<{
    handleCancel?: () => void;
    handleComplete?: () => void;
  }>;
  preventDefault?: boolean;
  headerClassName?: string;
  usesWithinDialog?: boolean;
}

export const FormDialog = ({
  open,
  setOpen,
  title,
  triggerLabel,
  form: Form,
  preventDefault,
  showTrigger = true,
  headerClassName,
  usesWithinDialog,
}: FormDialogProps) => {
  const handleOpenChange = () => setOpen(!open);

  Form = useNestedComponent(Form);

  const form = (
    <Form handleCancel={handleOpenChange} handleComplete={handleOpenChange} />
  );

  const body = usesWithinDialog ? form : <DialogBody>{form}</DialogBody>;

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      {showTrigger && (
        <DialogTrigger className="flex flex-row gap-2 p-2 rounded-lg hover:scale-110 duration-100 shadow-2xl">
          <PlusCircleIcon />
          {triggerLabel}
        </DialogTrigger>
      )}
      <DialogContent
        preventClickout={preventDefault}
        preventEscape={preventDefault}
      >
        <DialogHeader className={headerClassName}>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        {body}
      </DialogContent>
    </Dialog>
  );
};
